
import Vue, { PropType } from 'vue'

import PlantInfoMetric from '@/ui/components/plants/dashboard/PlantInfoMetric.vue'
import PlantHarvestChart from '@/ui/components/plants/fragments/PlantHarvestChart.vue'
import DashboardStatCard from '@/ui/controls/dashboard/DashboardStatCard.vue'

// import { sortByDate, sortDateDesc } from '@/helpers/sorters'
// import { parse, differenceInDays } from 'date-fns'

import Plant from '@/models/Plant'
import { formatNumber } from '@/helpers/formatters'
// import Harvest from '@/models/Harvest'
// import LogItem from '@/models/LogItem'

export default Vue.extend({
  components: {
    PlantInfoMetric,
    PlantHarvestChart,
    DashboardStatCard,
  },
  props: {
    plant: Object as PropType<Plant>,
  },
  data: () => ({
    // readonly: true,
  }),
  computed: {
    harvestAggregates() {
      return Plant.harvestAggregate
    },
    // lastWater(): LogItem | undefined {
    //   return this.lastOfCategory('water')
    // },
    // lastWaterDays(): number | undefined {
    //   if (!this.lastWater?.date) return undefined
    //   return differenceInDays(parse(this.lastWater.date, 'yyyy-MM-dd', new Date()), new Date().setHours(0, 0, 0, 0))
    // },
    // lastMilestone(): LogItem | undefined {
    //   return this.lastOfCategory('milestone')
    // },
    // lastHarvest(): Harvest | undefined {
    //   return this.plant.harvests
    //     .slice()
    //     .sort(sortDateDesc<Harvest>('date', sortDateDesc<Harvest>('createdAt')))[0]
    // },
  },
  methods: {
    formatNumber: formatNumber,
    // lastOfCategory(cat: string): LogItem | undefined {
    //   const logOrdered = this.plant.log
    //     .filter((l: LogItem) => l.category === cat)
    //     .sort(sortByDate(true))
    //   // if (logOrdered.length < 1) return undefined
    //   return logOrdered[0]
    // },
  },
})
